/**
 * Created by koqiui on 2017-04-09.
 */
import { Vue,MsgBox } from '../../app.vues';
import { Utils } from '../../app.base'
//
import SwbShopComnRepairDetail from './ShopComnRepairDetail';
Vue.regist(SwbShopComnRepairDetail);

import SwbShopComnRepairServicerList from './ShopComnRepairServicerList';
Vue.regist(SwbShopComnRepairServicerList);

import SwbShopComnRepairServicerPageList from './ShopComnRepairServicerPageList';
Vue.regist(SwbShopComnRepairServicerPageList);

import SwbShopComnRepairForSelect from './ShopComnRepairForSelect';
Vue.regist(SwbShopComnRepairForSelect);

import SwbComnSvcRequireSave from './ComnSvcRequireSave';
Vue.regist(SwbComnSvcRequireSave);
import SwbComnSvcRequireDetail from './ComnSvcRequireDetail';
Vue.regist(SwbComnSvcRequireDetail);
import SwbComnSvcRequireListForSelect from './ComnSvcRequireListForSelect';
Vue.regist(SwbComnSvcRequireListForSelect);

// 常规服务需求保存
export function openComnSvcRequireSaveDlg(params, callBack) {
    let id = params.id;
    let title = '常规服务需求 - 新增';
    if(!Utils.isNoB(id)) {
        title = '常规服务需求 - 编辑';
    }
    let theDlg = Vue.$showDialog({
        title: title,
        width: 700,
        height: 900,
        showCloseBtn: true,
        template: '<swb-comn-require-save :id="id" ref="swb_comn_require_save"></swb-comn-require-save>',
        data: {
            id: id
        },
        okClicked: function () {
            let result = this.$refs.swb_comn_require_save.getDlgResult();
            if(result.type == "info") {
                callBack(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        },
        lifecycle: {}
    });
}
// 常规服务需求详情
export function openComnSvcRequireDetailDlg(id) {
    let theDlg = Vue.$showDialog({
        title: "常规服务需求 - 查看",
        showCloseBtn: true,
        width: 600,
        height: 500,
        okVisible: false,
        cancelText: '关闭',
        template: '<swb-comn-require-detail :id="id" ref="swb_comn_require_detail"></swb-comn-require-detail>',
        data: {
            id: id
        },
        okClicked: function () {
        }
    });
}

// 常规服务需求 - 选择
export function openComnSvcRequireListForSelectDlg(params, callBack) {
    let filter = params.filter;
    let checkBox = Utils.isTrue(params.checkBox) || false;
    let disableInitCheckedSelection = Utils.isTrue(params.disableInitCheckedSelection);
    let selectIds = params.selectIds || [];
    let title = '常规服务需求 - 选择';
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1200,
        height: 800,
        showCloseBtn: true,
        template: '<swb-comn-require-list-for-select :filter="filter" :checkBox="checkBox" :selectIds="selectIds" :disableInitCheckedSelection="disableInitCheckedSelection" ref="swb_comn_require_list_for_select"></swb-comn-require-list-for-select>',
        data: {
            filter: filter,
            selectIds: selectIds,
            checkBox: checkBox,
            disableInitCheckedSelection: disableInitCheckedSelection
        },
        okClicked: function () {
            let result = this.$refs.swb_comn_require_list_for_select.getDlgResult();
            if(result.type == "info") {
                callBack(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        },
        lifecycle: {}
    });
}

// ==================== 门店可用常规需求 ===============================
export function openShopComnRepairDetailDlg(id) {
    Vue.$showDialog({
        title: "常规服务请求 - 查看",
        showCloseBtn: true,
        width: 600,
        height: 500,
        okVisible: false,
        cancelText: '关闭',
        template: '<swb-shop-comn-repair-detail :id="id"></swb-shop-comn-repair-detail>',
        data: {
            id: id
        },
        okClicked: function () {
        },
        lifecycle: {}
    });
}

export function openShopComnRepairServicerDlg(params, callBack) {
    let repairId = params.repairId;
    let add = Utils.isTrue(params.add) || false;
    let showDevice = Utils.isTrue(params.showDevice) || false;
    let servcCatId = params.servcCatId;
    let title = '常规服务商 -- 设置';
    if(Utils.isFalse(add)) {
        title = '常规服务商 -- 查看';
    }
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1200,
        height: 800,
        showCloseBtn: true,
        template: '<swb-shop-comn-repair-servicer :repairId="repairId" :add="add" :showRepair="true" :servcCatId="servcCatId" ref="swb_shop_comn_repair_servicer"></swb-shop-comn-repair-servicer>',
        data: {
            repairId: repairId,
            add: add,
            showDevice: showDevice,
            servcCatId: servcCatId
        },
        okClicked: function () {
            let result = this.$refs.swb_shop_comn_repair_servicer.getDlgResult();
            if(result.type == "info") {
                callBack(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        },
        lifecycle: {}
    });
}

export function openShopComnRepairServicerPageDlg(params, callBack) {
    let bizUnitId = params.bizUnitId;
    let title = '常规服务商 -- 设置';
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1300,
        height: 800,
        showCloseBtn: true,
        template: '<swb-shop-comn-repair-list-servicer-select :bizUnitId="bizUnitId"  ref="swb_shop_comn_repair_list_servicer_select"></swb-shop-comn-repair-list-servicer-select>',
        data: {
            bizUnitId: bizUnitId,
        },
        okClicked: function () {
            let result = this.$refs.swb_shop_comn_repair_list_servicer_select.getDlgResult();
            if(result.type == "info") {
                callBack(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        },
        lifecycle: {}
    });
}

export function openShopComnRepairSelecrtPageDlg(params, callBack) {
    let bizUnitId = params.bizUnitId;
    let servcTypeId = params.servcTypeId;
    let checkBox = Utils.isTrue(params.checkBox) || false;
    let disableInitCheckedSelection = Utils.isTrue(params.disableInitCheckedSelection);
    let checkedIds = params.checkedIds || [];
    let title = '常规服务请求 -- 选择';
    Vue.$showDialog({
        title: title,
        width: 1200,
        height: 800,
        showCloseBtn: true,
        template: '<swb-shop-comn-repair-list-for-select :bizUnitId="bizUnitId" :servcTypeId="servcTypeId" :checkBox="checkBox"  :checkedIds="checkedIds" :disableInitCheckedSelection="disableInitCheckedSelection" ref="swb_shop_comn_repair_list_for_select"></swb-shop-comn-repair-list-for-select>',
        data: {
            bizUnitId: bizUnitId,
            servcTypeId: servcTypeId,
            checkedIds: checkedIds,
            checkBox: checkBox,
            disableInitCheckedSelection: disableInitCheckedSelection
        },
        okClicked: function () {
            let result = this.$refs.swb_shop_comn_repair_list_for_select.getDlgResult();
            if(result.type == "info") {
                callBack(result.data);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {}
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/shopComnReq/dialog.js
// module id = 141
// module chunks = 0